// extracted by mini-css-extract-plugin
export var headerCell = "_5r-1";
export var loadingSpinnerContainer = "_5r-4";
export var rowWrapper = "_5r-3";
export var standaloneTable = "_5r-5";
export var table = "_5r-0";
export var white = "_5r-2";